import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Icon from '../Shared/Icon';
import Button from '../Buttons/Button';
import CircularProgress from '@mui/material/CircularProgress';

const Pod = props => {
    const theme = useTheme();
    // const [hover, setHover] = useState(false);

    // console.log('nouseeffect', hover)
    // useEffect(()=>{
    //     console.log(hover)
    // }, [hover])
    return (
        <Grid
            
        >
            { props.label &&
                <Grid
                    className="PodLabel"
                    sx={{
                        color: theme.palette[props.color || "offwhite"].main,
                        // display: hover ? 'block' : 'none'
                    }}
                >
                    {props.label}
                </Grid>
            }

            <Grid item
                className="Pod"
                onClick={props.handler}
                sx={{
                    background: theme.palette[props.color === "white" ? "white" : "offwhite"].light,
                    color: theme.palette[props.color || "offwhite"].main,
                    width: props.fullWidth ? 1 : 'auto',
                    '&:hover': {
                        cursor: 'pointer'
                    }
                }}
            >

                {props.icon &&
                    <Icon
                        icon={props.icon}
                        label={props.label}
                    />
                }

                <Grid item xs 
                sx={{ px: 0.5, overflow: 'hidden' }}
                >
                    {props.children}
                </Grid>

                <Grid>
                    {props.launch && <Button type="launch" small handler={props.launch} />}
                    {props.refresh && <Button type="refresh" small handler={props.refresh} />}
                    {props.delete && <Button type="delete" small handler={props.delete} />}
                    {props.loading && <CircularProgress size="small" />}
                </Grid>
            </Grid>

        </Grid>
    )
}
export default Pod;